import type { NativeCallState } from './nativeBridge';

export function canonicalNativeRoom(value: unknown): string | null {
  if (typeof value !== 'string' || !/^https:\/\/[a-z0-9-]+\.daily\.co(?::443)?\/[A-Za-z0-9_-]{1,255}$/.test(value)) return null;
  const url = new URL(value);
  return `${url.origin}${url.pathname}`;
}

/** Include every ownership transition, even when React batches pause/resume. */
export function nativeObservationKey(state: NativeCallState): string {
  return JSON.stringify([state.state, state.meetingId, state.operationId, state.accessId, state.generation,
    state.participantId, state.roomUrl, state.accessVerifying, state.cleanupPending,
    Object.values(state.participants || {}).filter(p => p && typeof p === 'object' && p.local).map(p => [p.session_id, p.user_id, p.owner, p.permissions])]);
}

export function joinedNativeObservation(state: NativeCallState, meetingId: string) {
  if (!state || typeof state !== 'object' || !state.participants || typeof state.participants !== 'object' || Array.isArray(state.participants)) return null;
  const room = canonicalNativeRoom(state.roomUrl);
  const locals = Object.values(state.participants).filter(p => p && typeof p === 'object' && p.local);
  if (state.state !== 'joined' || state.accessVerifying !== false || state.cleanupPending === true
    || state.meetingId?.toLowerCase() !== meetingId.toLowerCase() || !Number.isSafeInteger(state.generation) || state.generation! < 0
    || !state.accessId || !state.operationId || !state.participantId || !room || locals.length !== 1
    || locals[0].session_id !== state.participantId || !locals[0].user_id || typeof locals[0].owner !== 'boolean') return null;
  return { meetingId, accessId: state.accessId, operationId: state.operationId, generation: state.generation!,
    participantId: state.participantId, roomUrl: room, userId: String(locals[0].user_id), owner: locals[0].owner };
}
